var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkpill",class:{'checked': _vm.checked},on:{"click":_vm.onClick}},[_c('span',{staticClass:".pillcontent"},[_vm._v(_vm._s(_vm.$t(_vm.title)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }